




























































































































































import { Component, Prop } from "vue-property-decorator";
import { AgGridVue } from "ag-grid-vue";
import GridIconRowComponent from "../_shared/grid-components/grid-cells/grid-icon-row-component.vue";
import moment from "moment";
import { Order, OrderStatus } from "@/interfaces/order";
import { Grid } from "@/utils/grid/grid-helper";
import { PreferencesList } from "@/interfaces/preference";
import GridDateFilterComponent from "../_shared/grid-components/grid-filters/grid-date-filter-component.vue";
import GridFlagComponent from "../_shared/grid-components/grid-cells/grid-flag-component.vue";
import CommonSearchComponent from "../_shared/searchs/common-search-component.vue";
import GridListFilterComponent from "../_shared/grid-components/grid-filters/grid-list-filter-component.vue";
import GridRightIconsComponent from "../_shared/grid-components/grid-right-icons-component.vue";
import GridStatusChipComponent from "../_shared/grid-components/grid-cells/grid-status-chip-component.vue";
import store from "../../stores/store";
import router from "@/router/router";
import NewOrderModal from "./new-order-modal.vue";
import { Segment } from "@/interfaces/segment";
import { orderApiProvider } from "@/providers/order-api-provider";
import {User, UserRole} from "@/interfaces/user";
import { MessageType } from "@/components/_shared/template/app-snackbar.vue";
import GridPreferencesComponent from "@/components/_shared/grid-components/grid-preferences-component.vue";
import ConfirmModal from "@/components/_shared/modals/confirm-modal.vue";

@Component({
  name: "order-grid",
  components: {
    GridPreferencesComponent,
    AgGridVue,
    GridIconRowComponent,
    GridRightIconsComponent,
    CommonSearchComponent,
    GridFlagComponent,
    GridStatusChipComponent,
    NewOrderModal,
  },
})
export default class OrderGrid extends Grid {
  @Prop() rowData: Array<Order>;

  user = Object.assign(new User({}), store.getters["user/getUser"]);
  private exportDialog = false;
  private startDate: string | null = null;
  private endDate: string | null = null;
  private startDateMenu = false;
  private locale = store.getters["user/getLocale"];
  private endDateMenu = false;
  $refs: {
    newOrderModal: HTMLFormElement;
    config: HTMLFormElement;
    commonGridFilter: HTMLFormElement;
  };

  icons = [
    { icon: "mdi-delete", event: "remove-order", color: "kDartessRed", hide: this.user.isReader() },
    { icon: "mdi-pen", to: "/order/modify/?", hide: this.user.isReader() },
    { icon: "mdi-magnify", to: "/order/detail/?" },
  ];

  get formattedStartDate() {
    return this.startDate
      ? moment(this.startDate).format(this.$t("date.format.moment_date"))
      : this.$t("export_csv.select_date");
  }

  get formattedEndDate() {
    return this.endDate
      ? moment(this.endDate).format(this.$t("date.format.moment_date"))
      : this.$t("export_csv.select_date");
  }

  openExportModal() {
    this.exportDialog = true;
  }

  startExport() {
    this.exportDialog = false;
    this.exportData();
  }

  startRowExport() {
    if (!this.startDate || !this.endDate) {
      alert(this.$t("export_csv.date_required"));
      return;
    }

    const params = this.datasource.builder.build();
    params.append("start_date", this.startDate);
    params.append("end_date", this.endDate);

    orderApiProvider.exportAll(params, []);
    this.exportDialog = false;
  }

  async onClickNewOrder() {
    if (store.getters["createOrder/getCurrentOrderId"]) {
      this.$refs.newOrderModal.open();
    } else {
      await router.push("/order/create");
    }
  }
  generateItems() {
    const result: Array<object> = [];
    Order.getAllStatus().forEach((status) => {
      result.push({ code: status, name: Order.stringFromStatus(status) });
    });
    return result;
  }

  async beforeMount() {
    if (this.user.canUpdateStatus) {
      this.icons.push({ icon: "mdi-list-status", to: "/order/status/?" });
    }

    super.beforeMount();
    this.gridOptions.getRowClass = function (params: any) {
      if (params.data && params.data.statusCode == OrderStatus.draft) {
        return "kDartessNightBlue40";
      }
    };

    // Add superadmin specific columns.
    if ([UserRole.superadmin, UserRole.customeradmin].includes(store.getters["user/getUser"].role)) {
      this.columns.push({
        headerName: this.$t("owner.code"),
        field: "owner.code",
        cellClass: "cell-align-center",
      } as any);
      this.defaultPreference.columns.unshift("owner.name");
      this.columns.push({
        headerName: this.$t("owner.name"),
        field: "owner.name",
        width: 150,
        minWidth: 150,
        cellClass: "cell-align-center",
      } as any);
    }
  }

  defaultPreference = {
    slug: PreferencesList.order,
    columns: [
      "reference",
      "createdAt",
      "recipient.displayName",
      "deliveryDate",
      "appointmentDate",
      "preparationDate",
      "preparedQuantity",
      "orderedQuantity",
      "carrier.name",
      "recipient.country",
      "warehouse.name",
      "statusCode",
      "supportType",
    ],
  };

  columns = [
    {
      headerName: this.$t("order.reference"),
      field: "reference",
      width: 150,
      minWidth: 100,
      cellClass: "cell-align-left",
      valueFormatter: (params: any) => {
        return params.data?.reference ?? "-";
      },
    },
    {
      headerName: this.$tc("form.segment", 1),
      field: "segment",
      filterFramework: GridListFilterComponent,
      valueFormatter: function (params: any) {
        return params.data?.segment?.code ?? "-";
      },
      filterParams: {
        values: () => [...Segment.list.map((s) => ({ key: s.code, value: s.code }))],
      },
    },
    {
      headerName: this.$t("order.recipientReference"),
      field: "recipientReference",
      cellClass: "cell-align-left",
      width: 150,
      minWidth: 100,
      valueFormatter: (params: any) => {
        return params.data?.recipientReference ?? "-";
      },
    },
    {
      headerName: this.$t("recipient.name"),
      field: "recipient.displayName",
      cellClass: "cell-align-left",
      width: 150,
      minWidth: 150,
      valueFormatter: (params: any) => {
        return params.data?.recipient?.displayName ?? "-";
      },
    },
    {
      headerName: this.$t("order.orderedQuantity"),
      field: "orderedQuantity",
      filterFramework: null,
      cellClass: "cell-align-right",
      sortable: false,
      filterable: false,
    },
    {
      headerName: this.$t("order.preparedQuantity"),
      field: "preparedQuantity",
      filterFramework: null,
      cellClass: "cell-align-right",
      sortable: false,
      filterable: false,
    },
    {
      headerName: this.$t("carrier.code"),
      field: "carrier.code",
      width: 150,
      minWidth: 150,
    },
    {
      headerName: this.$t("carrier.name"),
      field: "carrier.name",
      width: 150,
      minWidth: 150,
      sortable: false,
      valueFormatter: (params: any) => {
        return params.data?.carrier?.name ?? "-";
      },
    },
    {
      headerName: this.$t("warehouse.name"),
      field: "warehouse.name",
      flex: 1,
      cellClass: "cell-align-left",
      filterFramework: null,
    },
    {
      headerName: this.$t("form.country"),
      field: "recipient.country",
      cellRendererFramework: "GridFlagComponent",
      cellClass: "cell-align-center",
      filterFramework: GridListFilterComponent, // Filtre personnalisé
      filterParams: {
        values: () => orderApiProvider.getCountries(),
        withSearch: true,
      },
    },
    {
      headerName: this.$t("form.created_date"),
      field: "createdAt",
      sort: "desc",
      filterFramework: GridDateFilterComponent,
      valueFormatter(params: any) {
        if (params.data && params.data.createdAt) {
          return moment(params.data?.createdAt).format("L");
        }
        return "-";
      },
    },
    {
      headerName: this.$t("order.deliveryDate"),
      field: "deliveryDate",
      filterFramework: GridDateFilterComponent,
      valueFormatter(params: any) {
        if (params.data && params.data.deliveryDate) {
          return moment(params.data?.deliveryDate).format("L");
        }
        return "-";
      },
    },
    {
      headerName: this.$t("order.appointmentDate"),
      field: "appointmentDate",
      filterFramework: GridDateFilterComponent,
      valueFormatter(params: any) {
        if (params.data && params.data.appointmentDate) {
          return moment(params.data?.appointmentDate).format("L");
        }
        return "-";
      },
    },
    {
      headerName: this.$t("order.preparationDate"),
      field: "preparationDate",
      filterFramework: GridDateFilterComponent,
      valueFormatter(params: any) {
        if (params.data && params.data.preparationDate) {
          return moment(params.data?.preparationDate).format("L");
        }
        return "-";
      },
    },
    {
      headerName: this.$t("order.exit_point"),
      field: "exitPoint",
    },
    {
      headerName: this.$t("order.statusCode"),
      field: "statusCode",
      cellRendererFramework: "GridStatusChipComponent",
      width: 165,
      minWidth: 165,
      cellRendererParams: { type: "order" },
      filterFramework: GridListFilterComponent,
      filterParams: {
        values: Object.values(OrderStatus).map((e: OrderStatus) => ({
          key: e,
          value: Order.stringFromStatus(e),
        })),
      },
    },
    {
      headerName: this.$t("order.supportType"),
      field: "supportType",
      width: 150,
      minWidth: 100,
      cellClass: "cell-align-left",
      valueFormatter: (params: any) => {
        return params.data?.supportType ?? "-";
      },
    },
    {
      headerName: this.$t("order.supportNumber"),
      field: "supportNumber",
      width: 100,
      minWidth: 100,
      cellClass: "cell-align-left",
      valueFormatter: (params: any) => {
        return params.data?.supportNumber ?? "-";
      },
    },
    {
      headerName: this.$t("order.documents"),
      field: "countDocuments",
      width: 150,
      minWidth: 100,
      cellClass: "cell-align-right",
      filterFramework: null,
      valueFormatter: (params: any) => {
        return params.data && params.data.countDocuments && params.data.countDocuments > 0
          ? params.data.countDocuments
          : "";
      },
    },
    {
      cellRendererFramework: "GridIconRowComponent",
      pinned: "right",
      cellClass: "cell-align-company",
      width: this.user.canUpdateStatus ? 150 : 110,
      minWidth: this.user.canUpdateStatus ? 150 : 110,
      maxWidth: this.user.canUpdateStatus ? 150 : 110,
      sortable: false,
      filterFramework: null,
      suppressMovable: true,
      resizable: true,
      valueGetter(params: any) {
        return {
          id: params.data?.id,
          active: [
            Order.canDeleteScope(params.data?.statusCode),
            Order.canModifyScope(params.data?.statusCode),
            Order.canShowScope(params.data?.statusCode),
            true,
          ],
        };
      },
      cellRendererParams: {
        icons: this.icons,
      },
    },
  ];

  sendTransmittingOrders() {
    const selectedOrders = this.gridOptions.api.getSelectedRows();
    orderApiProvider.sendTransmitingOrders(selectedOrders).then(() => {
      this.$eventHub.$emit("show-snackbar", {
        type: MessageType.success,
        mainText: this.$t("order.send-transmitting-orders.success"),
      });

      this.gridOptions.api.onFilterChanged();
    });
  }
}
